module.exports = __webpack_public_path__ + "img/liliana.5fa9a6e0.jpg";